import React from "react";
import "../styles/pagenot.scss";
import { Link } from "react-router-dom";
import PageTop from "../components/PageTop";
const NotFound = (props) => {
  return (
    <>
      {props.data.map((data, index) => {
        return (
          <>
            <PageTop text={data.PNF_pt_title}  url="https://images.unsplash.com/photo-1682686578601-e7851641d52c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" />

            <div className="pagenot parent">
              <div className="pagenot-container container-small">
                <div className="oops"></div>
                <Link className="btn-active error-btn" to="/">
                  {data.PNF_cta}
                </Link>
              </div>
            </div>
          </>
        );
      })}
    </>
  );
};

export default NotFound;
